module.exports = __webpack_public_path__ + "img/MapStyles_2Vector_1024@0,25x@0,25x.d4a2bc2e.png";